export default __webpack_public_path__ + "703367d15bcc1eb2d1f88a5e7631a112.svg";